(() => {
  if (customElements.get('slv-animated-search')) return;

  class SLVAnimatedSearch extends HTMLElement {
    connectedCallback() {
      if (this._slvReady) return;
      const input = this.querySelector('.slv-header-search__input');
      if (!input) return;
      this._slvReady = true;
      this._slvInput = input;
      this._slvTerms = [
        'Turbo Audio TA21-N45',
        '21 Inch Subwoofer',
        'TA12800-4C Amplifier',
        'TA118 18 Inch Subwoofer',
        'Professional Line Array',
        'TA15-1200 Elite',
        'DJ Power Amplifier',
        'Wireless Microphone',
        'Digital Sound Processor',
        'DJ Mixer Console',
        'PA Speaker System',
        'Speaker Cables'
      ];
      this._slvIndex = -1;
      this._slvTimer = null;
      this._slvFocused = false;
      this._slvOnFocus = () => {
        this._slvFocused = true;
        this._slvStop();
        input.placeholder = '';
      };
      this._slvOnInput = () => {
        this._slvStop();
        if (input.value) input.placeholder = '';
      };
      this._slvOnBlur = () => {
        this._slvFocused = false;
        if (input.value) {
          input.placeholder = '';
        } else {
          input.placeholder = '';
          this._slvStart();
        }
      };
      input.addEventListener('focus', this._slvOnFocus);
      input.addEventListener('input', this._slvOnInput);
      input.addEventListener('blur', this._slvOnBlur);
      this._slvStart();
    }

    disconnectedCallback() {
      this._slvStop();
      if (!this._slvInput) return;
      this._slvInput.removeEventListener('focus', this._slvOnFocus);
      this._slvInput.removeEventListener('input', this._slvOnInput);
      this._slvInput.removeEventListener('blur', this._slvOnBlur);
      this._slvReady = false;
    }

    _slvStop() {
      if (this._slvTimer) window.clearTimeout(this._slvTimer);
      this._slvTimer = null;
    }

    _slvStart() {
      this._slvStop();
      if (this._slvFocused || !this._slvInput || this._slvInput.value) return;
      this._slvTimer = window.setTimeout(() => this._slvType(), 120);
    }

    _slvType() {
      if (!this.isConnected || this._slvFocused || document.activeElement === this._slvInput || this._slvInput.value) return;
      let next = Math.floor(Math.random() * this._slvTerms.length);
      if (this._slvTerms.length > 1 && next === this._slvIndex) next = (next + 1) % this._slvTerms.length;
      this._slvIndex = next;
      const word = this._slvTerms[next];
      let position = 0;
      const typeNext = () => {
        if (!this.isConnected || this._slvFocused || document.activeElement === this._slvInput || this._slvInput.value) return;
        position++;
        this._slvInput.placeholder = word.slice(0, position);
        if (position < word.length) {
          this._slvTimer = window.setTimeout(typeNext, 29);
        } else {
          this._slvTimer = window.setTimeout(() => this._slvErase(word, position), 480);
        }
      };
      typeNext();
    }

    _slvErase(word, position) {
      if (!this.isConnected || this._slvFocused || document.activeElement === this._slvInput || this._slvInput.value) return;
      position--;
      this._slvInput.placeholder = word.slice(0, position);
      if (position > 0) {
        this._slvTimer = window.setTimeout(() => this._slvErase(word, position), 16);
      } else {
        this._slvTimer = window.setTimeout(() => this._slvType(), 80);
      }
    }
  }

  customElements.define('slv-animated-search', SLVAnimatedSearch);
})();